import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import useLanguage from '../../../hooks/useLanguage';
import PropTypes from 'prop-types';

import Star from '../../../svg/star_white.svg';

const Instagram = ({ insta }) => {


  const langToggle = useLanguage;
  const images = insta.instagram.insta_photo;

  return (
    <section className="instagram" data-scroll-section>
      <div className="content-wrapper">
        <header className="instagram-header">
          <div className="instagram-header__marker-wrapper">
            <span className="instagram-header__marker">Instagram</span>
          </div>
          <div className="instagram-header__title-wrapper">
            <h2 className="instagram-header__title">
              {langToggle(insta.title_ua, insta.title_ru)}
            </h2>
          </div>
        </header>
        <div className="instagram-body">
          <a
            href={insta.instagram.link}
            target="blank"
            className="instagram-body__link"
          >
            <span className="instagram-body__link-icon">
              <Star className="instagram-body__link-star" />
              <span className="instagram-body__link-title__wrapper">
                <span className="instagram-body__link-title">
                  {langToggle(
                    insta.instagram.title_ua,
                    insta.instagram.title_ru
                  )}
                </span>
              </span>
            </span>
          </a>
          <div className="instagram-body__images-wrapper">
            {images.map((item, index) => {
              const image = getImage(item.image.localFile);
              const count = ++index;
              return (
                <div
                  className={`instagram-body__image-item instagram-body__image-item__${count}`}
                  key={index}
                >
                  <GatsbyImage
                    className="instagram-body__image"
                    image={image}
                    alt="shoschool instagram image"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

Instagram.propTypes = {
  dataInstagram: PropTypes.object,
};

export default Instagram;
